<script lang="ts">
    export let json           : string;
    export let require_images : {[key: string]: boolean};

	let files  : FileList   = null;
	let is_err : boolean    = false;
 	let reader : FileReader = new FileReader();

	function doUpload() {
		reader.onload = function() {
            // 選択されたファイルが文字列型でなければエラー ex) binary:ArrayBuffer
            if (typeof reader.result !== 'string') {
                reset_json_upload();
                return;
            }

            json = reader.result;
            let json_list : object = JSON.parse(json);

            // JSON内に使用する項目が含まれているかを確認
            if (json_list['Hairishes'] == null
                 || json_list['_HairBoneStore']['Groups'] == null
                 || json_list['_MaterialSet']['_Materials'] == null) {
                reset_json_upload();
                return;
            }

            // マテリアルで使用している画像リストを作成
            json_list['_MaterialSet']['_Materials'].forEach(material => {
                require_images[material['_MainTextureId']] = false;
            });

            is_err = false;
		}
		reader.readAsText(files[0]);
	}

    /** 選択ファイルに関わるデータを初期化する
     * 
     */
    function reset_json_upload() {
        json           = '';
        require_images = {};
        is_err         = true;
    }
</script>

<div>
    <p>合成したい髪型を選択してください。(preset.json)</p>
    <input id='json' type="file" accept="application/json" bind:files on:change={doUpload} />
</div>
